// 导入所有 housekeeping 模块的国际化文件
import { messages as housekeepingMessages } from '@/lang/housekeeping/housekeepingLang.js'
import { messages as servAppraiseManageMessages } from '@/lang/housekeeping/servAppraiseManageLang.js'
import { messages as resourceStoreTypeMessages } from '@/lang/housekeeping/resourceStoreTypeLang.js'
import { messages as housekeepingTypeMessages } from '@/lang/housekeeping/housekeepingTypeLang.js'
import { messages as housekeepingServPoolUserMessages } from '@/lang/housekeeping/housekeepingServPoolUserLang.js'
import { messages as housekeepingServPoolPayOrderMessages } from '@/lang/housekeeping/housekeepingServPoolPayOrderLang.js'
import { messages as housekeepingServPoolPayMessages } from '@/lang/housekeeping/housekeepingServPoolPayLang.js'
import { messages as housekeepingServDetailMessages } from '@/lang/housekeeping/housekeepingServDetailLang.js'
import { messages as housekeepingResourceMessages } from '@/lang/housekeeping/housekeepingResourceLang.js'
import { messages as housekeepingFeeTypeMessages } from '@/lang/housekeeping/housekeepingFeeTypeLang.js'
import { messages as housekeepingFeeConfigMessages } from '@/lang/housekeeping/housekeepingFeeConfigLang.js'
import { messages as housekeepingDispatchManageMessages } from '@/lang/housekeeping/housekeepingDispatchManageLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...housekeepingMessages.en,
        ...servAppraiseManageMessages.en,
        ...resourceStoreTypeMessages.en,
        ...housekeepingTypeMessages.en,
        ...housekeepingServPoolUserMessages.en,
        ...housekeepingServPoolPayOrderMessages.en,
        ...housekeepingServPoolPayMessages.en,
        ...housekeepingServDetailMessages.en,
        ...housekeepingResourceMessages.en,
        ...housekeepingFeeTypeMessages.en,
        ...housekeepingFeeConfigMessages.en,
        ...housekeepingDispatchManageMessages.en
    },
    zh: {
        ...housekeepingMessages.zh,
        ...servAppraiseManageMessages.zh,
        ...resourceStoreTypeMessages.zh,
        ...housekeepingTypeMessages.zh,
        ...housekeepingServPoolUserMessages.zh,
        ...housekeepingServPoolPayOrderMessages.zh,
        ...housekeepingServPoolPayMessages.zh,
        ...housekeepingServDetailMessages.zh,
        ...housekeepingResourceMessages.zh,
        ...housekeepingFeeTypeMessages.zh,
        ...housekeepingFeeConfigMessages.zh,
        ...housekeepingDispatchManageMessages.zh
    }
} 